export const verstaki = {
    slesarnie_type: [
        {
            actual: true,
            name: "verstak__vs__osnovanie__1200x630",
            pageName: "vs",
            tempName: "vs",
            glbPath: "verstaki/",
            glbName: "verstak__vs.glb",
            nextMenu: "vs",
            menuTitle: 'Верстак "ВС"',
            title: 'Верстак "ВС"',
            imgName: "verstak__vs.webp",
            allArrTable: "allVerstaki",
            defaultWidth: "1200",
            defaultDepth: "630",
        },
    ],
};
